<div class="container p-3" >
    <div class="row mb-5 border-bottom">
        <div class="col text-center">{{ (userInfo | async)?.username }}</div>
    </div>
    <div class="row">
        <div class="col">
            <div class="d-grid gap-2">
                <button class="btn btn-primary" type="button" (click)="logout()">Cerrar sesión</button>
            </div>
        </div>
    </div>
</div>
